
import wixWindow from 'wix-window';

$w.onReady(function () {
	//TODO: write your page related code here...

});

//***********************
//Dispaly and Hide BackToTop Button when scrolling
//***********************
function showBackToTopbutton(){
	try {
		$w('#boxBackToTop').show("FadeIn");
	} catch (err) {
	}
	
}

function hideBackToTopbutton(){
	try {
		$w('#boxBackToTop').hide("FadeOut");
	} catch (err) {
	}
	
}


export function header_viewportLeave(event) {
	
	// if (wixWindow.formFactor === "Desktop") {
	// 	showBackToTopbutton();
	// 	let fadeOptions = {
	// 	"duration":   300,
	// 	"delay":      500
	// 	};
	// 	$w('#headerStripSmall').show("fade",fadeOptions);
	// 	//$w('#socialBarSmall').show("fade",fadeOptions);
	// 	$w('#menuSmall').show("fade",fadeOptions);
	// 	$w('#imgLogoSmall').show("fade",fadeOptions);

	// 	//$w('#headerStripBig').collapse();
	// 	$w('#headerStripBig').hide("fade",fadeOptions);
	// 	//$w('#socialBarBig').hide("fade",fadeOptions);
	// 	$w('#menuBig').hide("fade",fadeOptions);
	// 	$w('#imgLogoBig').hide("fade",fadeOptions);
	// }
}


export function header_viewportEnter(event) {
	
	// if (wixWindow.formFactor === "Desktop") {
	// 	hideBackToTopbutton();
	// 	//console.log("this is Desktop");
	// 	let fadeOptions = {
	// 	"duration":   300,
	// 	"delay":      0
	// 	};
	// 	$w('#headerStripBig').show("fade", fadeOptions);
	// 	//$w('#socialBarBig').show("fade",fadeOptions);
	// 	$w('#menuBig').show("fade",fadeOptions);
	// 	$w('#imgLogoBig').show("fade",fadeOptions);

	// 	$w('#headerStripSmall').hide("fade", fadeOptions);
	// 	//$w('#socialBarSmall').hide("fade",fadeOptions);
	// 	$w('#menuSmall').hide("fade",fadeOptions);
	// 	$w('#imgLogoSmall').hide("fade",fadeOptions);

	// }
}




